const tutorialSectionStyle = {
  gridContainer: {
    backgroundColor: "white",
    padding: "0px",
    width: "100%"
  },
  gridHeader: {
    width: "100%",
    padding: "0px 10px",
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid gray",
    height: "fit-content",
    justifyContent: "space-between"
  },
  inputContainer: {
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%"
  },
  gridHeaderRight: {
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: "10px"
  },
  gridHeaderLeft: {
    display: "flex",
    alignItems:"center"
  },
  title: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }

};

export default tutorialSectionStyle;
